import * as React from 'react'; 
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";

interface IProps {
  children?: React.ReactNode;
}

const PaneBody = (props: IProps) => {
  return (
    <OverlayScrollbarsComponent 
      element="div"
      className='scroller'
      defer 
      options={{ scrollbars: { theme: 'os-theme-light', autoHide: 'leave' }}}
      style={{
        flex: 1,
        overflowY: 'auto',
        padding: '16px 20px 16px 16px',
        boxSizing: 'border-box'
      }}
    >
      {props.children}
    </OverlayScrollbarsComponent>
  )
}

export { PaneBody }
